// src/pages/Logs.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Toolbar,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
} from "@mui/material";
import { getLogs } from "../services/api";

// Utility to format date/time
const fmtDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  return isNaN(d) ? "—" : d.toLocaleString();
};

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadLogs() {
      try {
        const res = await getLogs();
        setLogs(res.data?.data || res.data || []); // match API shape
      } catch (err) {
        console.error("Failed to fetch logs", err);
      } finally {
        setLoading(false);
      }
    }
    loadLogs();
  }, []);

  return (
    <Box>
      <Toolbar />
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
          System Logs
        </Typography>

        <Paper sx={{ p: 2, borderRadius: 3 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
              <CircularProgress />
            </Box>
          ) : logs.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No logs found.
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Module</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>IP</TableCell>
                  <TableCell>User Agent</TableCell>
                  <TableCell>Timestamp</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell>{log.id}</TableCell>
                    <TableCell>
                      {log.user?.name || log.user?.email || "System"}
                    </TableCell>
                    <TableCell>
                      <Chip size="small" label={log.module} color="primary" />
                    </TableCell>
                    <TableCell>{log.action}</TableCell>
                    <TableCell>{log.description || "—"}</TableCell>
                    <TableCell>{log.ipAddress || "—"}</TableCell>
                    <TableCell
                      sx={{ maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      {log.userAgent || "—"}
                    </TableCell>
                    <TableCell>{fmtDate(log.createdAt)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
